import styled from "styled-components";
import { device } from "../../styles/devices";

export const DataAboutContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.9rem;
    margin-bottom: 2rem;

    @media ${device.tabletLarge}{
        grid-template-columns: repeat(3, 160px);
        justify-content: center;
    }

    @media ${device.tablet}{
        grid-template-columns: repeat(3, 1fr);
    }

    @media ${device.mobile}{
        grid-template-columns: repeat(2, 1fr);
        align-items: center;
    }

    div{
        background-color: var(--color-white);
        border: 1px solid rgba(0,0,0,0.1);
        border-radius: 0.75rem;
        text-align: center;
        padding: 1rem 1rem;
        color: var(--color-text);
        transition: background-color .3s;

        @media screen and (max-width: 600px){
            padding: 0.5rem;
            text-align: center!important;;
        }

        &:hover{
            background-color: var(--color-white-hover);
        }

        i{
            font-size: 2rem;
            color: var(--color-title);
            margin-bottom: .5rem;
            display: block;
        }

        h3{
            font-size: 1rem;
            line-height: 1.5rem;
            font-weight: var(--font-medium);
            color: var(--color-title);
            margin-bottom: .5rem;
        }

        p {
            font-size: 0.875rem!important;
            padding: 0!important;
            margin-bottom: 0!important;
            text-align: center!important;
        }
    }

`;